const partners = ['microsoft', 'aws', 'red-hat', 'nvidia', 'astrapay', 'gotoko', 'dana', 'telkomsat', 'btpns', 'best', 'bri', 'prakerja', 'jet-brains', 'binus', 'uic-college']
export default partners
